import { gql } from "@apollo/client";

const GET_MY_BOTS = gql`
  query GetMyBots {
    getMyBots {
      bots {
        id
        botId
        name
        description
        enabled
        createdAt
        launcherImageUrl
        deploymentCount
        knowledgeSourceCount
      }
      total
    }
  }
`;
export default GET_MY_BOTS;
